export const SET_STATUS = 'SET_STATUS';
export const SET_ALL_STATUSES = 'SET_ALL_STATUSES';
export const SET_STATUS_LOADING = 'SET_STATUS_LOADING';
